<template>
  <div class="content">
    <span class="head">{{chartLabel}}</span>
    <doughnut-chart class="chart" :data="chartData" />
  </div>
</template>

<script>
import DoughnutChart from '@/components/charts/DoughnutChart';

const capitalise = str => `${str[0].toUpperCase()}${str.slice(1).toLowerCase()}`;

export default {
  name: 'DemographicsItem',

  props: {
    data: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: '',
    },
  },

  computed: {
    chartData() {
      const limit = 10;
      return this.data.length > limit ? this.data.slice(0, limit) : this.data;
    },

    chartLabel() {
      // Pad start with fixed width characters to align as close as possible to the center
      return this.label ? capitalise(this.label).padStart(7, ' ') : '';
    },
  },

  components: {
    DoughnutChart,
  },
};
</script>

<style lang="scss" scoped>
.head {
  position: absolute;
  font-weight: bold;
  width: 25px;
  padding: 0;
  left: calc(50% - 2.5rem);
  top: calc(50% - 1rem);
}

.chart {
  width: 250px;
}

.content {
  position: relative;
  clear: both;
  margin: 10px auto;
}
</style>



// WEBPACK FOOTER //
// DemographicsItem.vue?a81460a6